<!-- 校本选课-学生端-待选课程 -->
<template>
<div class="body">
  <div class="index" v-loading="loading" v-show="!detail.show">
    <div class="header_title">待选课程</div>
    <div class="index_box">
      <template v-if="dataList.length">
        <div
          class="box"
          v-for="(item_all, i) in dataList"
          :key="'course_key' + i"
          :style="{ 'margin-top': `${i >= 0 ? '10px' : ''}` }"
        >
          <template v-if="item_all.courseList && item_all.courseList.length">
            <div
              class="red_state"
              v-if="
                item_all.courseList[0].remainTime ||
                (item_all.studentEndTime &&
                  getEndDistance(item_all.studentEndTime))
              "
            >
              <img src="@/assets/img/courseSelection/red_clock.svg" alt="" />
              <p>
                距选课结束还剩
                {{
                  item_all.courseList[0].remainTime ||
                  getEndDistance(item_all.studentEndTime)
                }}
              </p>
            </div>

            <div
              class="box_p"
              v-for="(item, j) in item_all.courseList"
              :key="'course_key_s' + j"
               @click="toDetail(item)"
              :style="{
                'border-radius': `${
                  item_all.courseList.length > 1
                    ? j === 0
                      ? '12px 12px 0px 0px'
                      : j === item_all.courseList.length - 1
                      ? '0px 0px 12px 12px'
                      : '0px'
                    : ''
                }`,
              }"
            >
              <div class="box_top">
                <!-- <img :src="item.pic" alt="" class="box_top_img" v-if="item.pic"/>
                <template v-else> -->
                <img
                  src="@/assets/img/courseSelection/study.svg"
                  class="box_top_img"
                  alt=""
                  v-if="item.typeName !== '作业辅导'"
                />
                <img
                  src="@/assets/img/courseSelection/job.svg"
                  class="box_top_img"
                  alt=""
                  v-if="item.typeName == '作业辅导'"
                />
                <!-- </template> -->
                <div class="box_top_font">
                  <div class="box_top_title">
                      <span  v-if="item.courseName" style="display: inline-block;" class="course_name">{{ item.courseName }} </span>
                      <span  v-if="item.typeName" style="display: inline-block;margin:0 0 0 10px"  class="course_text">{{ item.parentTypeName?item.parentTypeName+' - ':'' }}{{item.typeName }}</span>
                  </div>
                  <!-- <p class="course_name" v-if="item.courseName">
                    {{ item.courseName }}
                  </p>
                  <div class="course_text" v-if="item.typeName">
                    {{ item.parentTypeName?item.parentTypeName+' - ':'' }}{{item.typeName }}
                  </div> -->

                  <div class="course_last">
                    <div
                      class="course_text mr-30"
                      v-if="item.teacherName"

                    >
                      <span>任课教师：</span>
                      <span>{{ item.teacherName }}</span>
                    </div>
                    <div
                      class="course_text mr-30"
                      v-if="item.classTimeName"

                    >
                      <span>上课时间：</span>
                      <span>{{ item.classTimeName }}</span>
                    </div>

                    <div
                      class="selected_box"
                      v-if="item.totalLimit"
                    >
                      <span class="font-gray">选课人数</span>
                      <div class="progress_box" v-if="item.totalLimit != 99999">
                        <div class="progress_outside">
                          <div
                            class="progress_Within"
                            :style="{
                              width: `${
                                ((item.selectedCount || 0) /
                                  1 /
                                  ((item.totalLimit || 0) / 1)) *
                                114
                              }px`,
                            }"
                          ></div>
                        </div>
                        <div>
                          <span style="color: #4991e1">{{
                            item.selectedCount || 0
                          }}</span>
                          <span style="color: #000000"
                            >/{{ item.totalLimit || 0 }}</span
                          >
                        </div>
                      </div>
                      <p style="margin-left: 10px" v-else>人数不限</p>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn" :disabled="getBtnText(item)!='立即报名'"  @click.stop="selectionCourse(item)" >{{getBtnText(item)}}</button>
            </div>
          </template>  
        </div>
      </template>
      <!-- 暂无数据 -->
      <template v-if="!dataList.length">
        <div class="no_data">
          <img src="@/assets/img/courseSelection/no_data.svg" alt="" />
          <p>暂无待选课程哦~</p>
        </div>
      </template>
    </div>
  </div>
  <Detail :info="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
</div>
</template>
<script>
import util from "@/utils/util.js";
import _ from "lodash";
import api from "@/api/wisdomSchool/index";
import Detail from "./detail.vue";
export default {
  data() {
    return {
      loading: false,
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      class_id: "",
      dataList: [],
      detail: {
        info: {},
        show: false,
      },
    };
  },
  components:{ Detail },
  created() {
    // 获取班级信息
    let classList = this.userInfo.user_org.filter((e) => e.org_type == "7");
    this.class_id = classList[0]?.org_id;
    this.getList();
  },
  mounted() {},
  methods: {
    getEndDistance(studentEndTime) {
      if (
        studentEndTime &&
        Date.parse(studentEndTime.replace(/-/g, "/")) > Date.parse(new Date())
      ) {
        return util.endDistance(
          new Date(),
          new Date(studentEndTime.replace(/-/g, "/"))
        );
      } else {
        return "";
      }
    },
    async getList() {
      try {
        this.loading = true;
        console.log("用户信息", this.userInfo);
        // return
        let params = {
          platformCode: sessionStorage.loginPlatformCode,
          orgId: sessionStorage.orgId,
          studentId: this.userInfo.user_id,
          classId: this.class_id,
        };
        let res = await api.waitingList(params);
        if (res.code === "0") {
          this.dataList = res.data;
        }
        console.log("待选/已选列表", res);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    toDetail(item){
      console.log('查看详情',item);
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex(){
      this.detail.show = false;
      this.getList()
    },
    selectionCourse: _.throttle(
      async function (item) {
          try {
              let params = {
                  courseApplyId: item.id,
                  platformCode: sessionStorage.loginPlatformCode,
                  userId: this.userInfo.user_id,
                  classId:this.class_id,
                  orgId: sessionStorage.orgId,
                  creatorId: this.userInfo.user_id,
              }
              let res = await api.selectCourse(params);
              if(res.code === '0'){
                this.$message.success({
                    message: "报名成功",
                    offset: 200,
                    customClass: "toast-classManage",
                    duration: 1500,
                  })
                this.getList();
              }else{
                this.$message.error({
                    message: res.msg,
                    offset: 200,
                    customClass: "toast-classManage",
                    duration: 1500,
                  })
              }
            } catch (err) {
              console.log(err);
            } finally {
            }
      },
      3000,
      { leading: true, trailing: false }
    ),
     getBtnText(item,type='待选课程') {
      if (item) {
        switch (item.status) {
          case 1:
          case '1':
            return '报名未开始';
          case 2:
          case '2':
            if (type === '待选课程'){
              if (item.selectedCount < item.totalLimit) {
                return '立即报名';
              } else {
                return '名额已满';
              }
            }else{
              return '取消报名';
            }
          case 3:
          case '3':
          case 4:
          case '4':
            return '报名已截止';
          case 5:
          case '5':
            return '开课中';
        }
      } else {
        return '无法报名';
      }
    },
  },
};
</script>
<style lang="less" scoped>
.body{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.index {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow: hidden;
  .header_title {
    width: calc(100% - 58px);
    text-align: center;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
    padding-top: 17px;
    padding-bottom: 15px;
    margin-left: 20px;
    border-bottom: 1px solid #ececec;
  }
  .index_box {
    width: 100%;
    height: calc(100% - 48px);
    padding: 0 20px 20px;
    overflow: auto;
    background-color: #ffffff;
    .box {
      width: 100%;
      margin-top: 20px;
      position: relative;
      .box_p {
        width: 100%;
        background: #f6f9fc;
        border-radius: 12px;
        padding: 12px 15px;
        position: relative;
        left: 0;
        bottom: 0;
        z-index: 1;
        display: flex;
        align-items: center;
      }
      .box_top_img {
        width: 110px;
        height: 82px;
        margin-right: 15px;
      }
      .box_top {
        display: flex;
        margin-top: 10px;
        width: calc(100% - 60px);
        cursor: pointer;
        .box_top_font {
          width: calc(100% - 127px);
          .box_top_title{
            display: flex;
            align-items: center;
          }
          .course_name {
            font-size: 18px;
            line-height: 25px;
            display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
            -webkit-line-clamp: 1; //限制行数
            overflow: hidden; //超出部分隐藏
            text-overflow: ellipsis; //用一个省略号代替超出的内容
          }
          .course_text {
            color: #888888;
            font-size: 12px;
            line-height: 17px;
            margin-top: 5px;
            font-size: 12px;
            line-height: 17px;
            margin-top: 5px;
             display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
            -webkit-line-clamp: 1; //限制行数
            overflow: hidden; //超出部分隐藏
            text-overflow: ellipsis; //用一个省略号代替超出的内容
          }
        }
      }

      // .course_last {
      //   display: flex;
      //   align-items: center;
      //   flex-wrap: wrap;
      // }
      .selected_box {
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 17px;
        color: #9b9b9b;
        margin-top: 5px;
        .progress_box {
          display: flex;
          align-items: center;
          margin-left: 6px;

          .progress_outside {
            position: relative;
            width: 114px;
            height: 10px;
            background: #e8f0fa;
            border-radius: 25px;
            margin-right: 11px;
            .progress_Within {
              position: absolute;
              left: 0;
              top: 0;
              height: 10px;
              background: linear-gradient(270deg, #41a4ff 50%, #7ec1ff 89.51%);
              border-radius: 25px;
            }
          }
        }
      }
      .red_state {
        width: 100%;
        height: 46px;
        background: #ffe9ed;
        border-radius: 12px 12px 0px 0px;
        position: relative;
        left: 0;
        top: 12px;
        z-index: 0;
        padding: 7px 15px 20px;
        font-size: 13px;
        line-height: 18px;
        color: #fa5151;
        display: flex;
        align-items: center;
        img {
          margin-right: 7px;
        }
      }
    }
  }
  .btn {
    width: 70px;
    height: 29px;
    color: #4991E1;
    border: 1px solid #4991E1;
    border-radius: 3px;
    font-size: 14px;
    line-height: 20px;
    background-color: #ffffff;
    cursor: pointer;
  }
   .btn[disabled] {
    opacity: 0.5;
    cursor: no-drop;
    color: #888888;
    border: 1px solid #888888;
  }
  .mr-30 {
    margin-right: 30px;
  }
  .no_data {
    margin: 30% calc(50% - 49px);
    text-align: center;
    p {
      width: 110px;
      font-size: 13px;
      line-height: 18px;
      color: #b2b2b2;
    }
  }
}
</style>